import React, { useEffect, useRef } from 'react';
import { Icon, StandAloneLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import useToggle from '../../../hooks/useToggle';
import Classes from './DescriptionButton.module.scss';

const DescriptionButton = () => {
  const { t } = useI18nContext();
  const descriptionRef = useRef<HTMLDivElement | null>(null);
  const isMountingRef = useRef(false);
  const [isCollapsed, toggle] = useToggle(true, '[data-collapse-target="description"]', 'data-collapsed');

  useEffect(() => {
    if (!isCollapsed) {
      isMountingRef.current = true;
    }
    if (isCollapsed && isMountingRef.current) {
      descriptionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isCollapsed]);

  return (
    <div className={`${Classes.root} DescriptionButton-root`} ref={descriptionRef}>
      <StandAloneLink onClick={toggle}>
        {isCollapsed ? t('listing.description.expand') : t('listing.description.collapse')}
        <Icon name={isCollapsed ? 'arrow-down-regular' : 'arrow-up-regular'} color="background-info-default" />
      </StandAloneLink>
    </div>
  );
};

export default DescriptionButton;
